import React, { useContext, useEffect, useState, useMemo } from "react";
import styled from "styled-components";
import { d_n5, d_n4 } from "./DB";
import T from "./TheTool";
import img1 from "./i01.png";
import img1c from "./i01c.png";
import img2 from "./i02.png";
import img3 from "./i03.png";
import { Button, Button2, theme } from "./CSS";
//https://react.school/ui/button
// Watch the Button tutorial http://react.school/ui/button
// Free React training http://react.school/join
// Free Material-UI template http://react.school/material-ui/templates
//https://reactgo.com/react-global-variable/

var qTargetIndex = 0;
var charBlink = 0;
var qTarget = ["", "", "", ""];

const SceneKanji = (props) => {
	const [qStage, setQStage] = useState(0); //0 load, 1 wait for ans, 2 correct, 3 wrong
	const [qMain, setQMain] = useState("");//MainKanji
	const [qSub, setQSub] = useState("");//
	const [qAns, setQAns] = useState(["", "", "", ""]);//Ans Item
	const [qChoices, setQChoices] = useState([
		"Choice1",
		"Choice2",
		"Choice3",
		"Choice4",
	]);//text on buttons
	const [cImg, setCImg] = useState(img1);

	useEffect(() => {
		const interval = setInterval(() => {
			charBlink++;
			if (charBlink > 25) {
				charBlink = 0;
			}
			if (charBlink > 23) {
				setCImg(img1c);
				// return img1c;
			} else {
				// return img1;
				setCImg(img1);
			}
		}, 100);
		return () => clearInterval(interval);
	}, []);


	if (qStage < 1) {
		//set new Q
		setQStage(1);
		var d = d_n5;
		if(window.$mode == "2"){ d = d_n4;}
		const arr = T.genRand(4, d.length);
		// console.log('Indices: ' + arr);
		T.shuffleArray(arr);
		var cc = ["?", "?", "?", "?"];
		for (i = 0; i < 4; i++) {
			if (d[arr[i]] != undefined && d[arr[i]][3] != undefined) {
				cc[i] = T.commaLimit(d[arr[i]][3], 2);
			}
			else{
				console.log('ERROR: ' + d[arr[i]]);//bef update
			}
		}
		setQChoices(cc);
		// console.log('Choices: ' + cc);
		// console.log('QChoices: ' + qChoices);//bef update
		var i = getRandomInt(4);
		qTargetIndex = i;
		qTarget = d[arr[i]];
		//
		var s = "";
		var j = getRandomInt(2);
		if(j == 1){
			s = T.splitLimit(" ",qTarget[2],2); 
			if(s == ""){ s = T.splitLimit(" ",qTarget[1],1);  }
		}
		else{
			s = T.splitLimit(" ",qTarget[1],2); 
			if(s == ""){ s = T.splitLimit(" ",qTarget[2],1);  }
		}
		setQMain(qTarget[0]);
		setQSub(s);
		setQAns(d[arr[i]]);
	}

	//---------------------------------------------------------------
	function DoClickSetting() {
		props.parentCallback(1);
	}

	function partTopTxt() {
		if (qStage == 3) {
			return <font color="red">Wrong!</font>;
		} 
		else if (qStage == 2) {
			return <font color="green">Correct!!</font>;
		} 
		else {
			return "Meaning?";
		}
		
	}

	function partChar() {
		if (qStage == 3) {
			return <img src={img3} alt="Char" width="150" />;
		} 
		else if (qStage == 2) {
			return <img src={img2} alt="Char" width="150" />;
		} 
		else {
			return <img src={cImg} alt="Char" width="150" />;
		}
	}

	function partTop() {
		return (
			<>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<div>
						{partChar() }
					</div>
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							flexDirection: "column",
						}}
					>
						{partTopTxt() }
						<font size="100">{qMain}</font>
						<font size="1">{qSub}</font>
						<font size="1">&nbsp;</font>
						{/* &nbsp;  */}
						<Button2 onClick={() => DoClickSetting()}>Settings</Button2>
					</div>
				</div>
			</>
		);
	}

	function partCenter() {
		if (qStage > 1) {
			return <GetResults />;
		} else {
			return <GetChoices />;
		}
	}

	function partBottom() {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<font size="2">Kotoba-chan&nbsp;</font>
				<font size="1">extension by Pujana P</font>
			</div>
		);
	}

	const DoClick = (i) => {
		if (i == qTargetIndex) {
			setQStage(2);
		} else {
			setQStage(3);
		}
	};

	const buttonColor = () => {
		if (qStage == 3) {
			return "pink";
		} else {
			return "green";
		}
	}


	//--------------------------------
	function GetChoices() {
		return (
			<div>
				<table width="100%">
					<tr width="100%">
						<td width="50%">
							{" "}
							<Button onClick={() => DoClick(0)}>{qChoices[0]}</Button>
						</td>
						<td width="50%">
							{" "}
							<Button onClick={() => DoClick(1)}>{qChoices[1]}</Button>
						</td>
					</tr>
					<tr width="100%">
						<td width="50%">
							{" "}
							<Button onClick={() => DoClick(2)}>{qChoices[2]}</Button>
						</td>
						<td width="50%">
							{" "}
							<Button onClick={() => DoClick(3)}>{qChoices[3]}</Button>
						</td>
					</tr>
				</table>
			</div>
		);
	}

	const DoClickR = (i) => {
		//if (qStage > 1) {
		setQStage(0);
		// setChar();
		// alert("You RRR me!" + qStage);
	};

	function GetResults() {
		return (
			<>
				<div>&nbsp;</div>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						width: "100%",
					}}
				>
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							flexDirection: "column",
							width: "100%",
						}}
					>
						<div>
							{qAns[1]} {qAns[2]}
						</div>
					</div>
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							flexDirection: "column",
							width: "100%",
						}}
					>
						<div>{qAns[3]}</div>
						<Button theme={buttonColor()} onClick={() => DoClickR()}>
							Next
						</Button>
					</div>
				</div>
			</>
		);
	}

	return (
		<>
			{partTop()}
			{partCenter()}
			{partBottom()}
		</>
	);
};

function getRandomInt(max) {
	return Math.floor(Math.random() * max);
}

export default SceneKanji;
